
$(document).ready(function ($) {
    // cart button temp fix
    if($('.site-header-cart .cart-click').length) {
        $('.site-header-cart .cart-click').parent().on('click', function (e) {
            e.stopPropagation();
            e.preventDefault();
            window.location = '/cart/';
        });

    }

    if($('.woosg-products').length < 1) {
        if ($('.available-variations').length) {
            $('.available-variations').each(function () {
                const $options = $(this);
                const $form = $options.closest('form.cart');
                $form.find('.variation_id').val($options.val());
            });
            $('.available-variations').on('change', function () {
                const $form = $(this).closest('form.cart');
                $form.find('.variation_id').val($(this).val());
            });
        }

        $('.single_add_to_cart_button').on('click', function (e) {
            e.preventDefault();
            const $thisbutton = $(this),
                $form = $thisbutton.closest('form.cart'),
                id = $thisbutton.val(),
                product_qty = $form.find('input[name=quantity]').val() || 1,
                product_id = $form.find('input[name=product_id]').val() || id,
                variation_id = $form.find('input[name=variation_id]').val() || 0;
            var data = {
                action: 'mtc_woocommerce_ajax_add_to_cart',
                product_id: product_id,
                product_sku: '',
                quantity: product_qty,
                variation_id: variation_id
            };
            $.ajax({
                type: 'post',
                url: wc_add_to_cart_params.ajax_url,
                data: data,
                beforeSend: function (response) {
                    $thisbutton.removeClass('added').addClass('loading');
                },
                complete: function (response) {
                    $thisbutton.addClass('added').removeClass('loading');
                },
                success: function (response) {
                    if (response.error & response.product_url) {
                        window.location = response.product_url;
                        return;
                    } else {
                        $(document.body).trigger('added_to_cart', [response.fragments, response.cart_hash, $thisbutton]);
                    }
                },
            });
        });

    }

  
    
});



